// import React from 'react'

// import { useClass } from '@/hooks/useClass'

// const tagColor = {
//   primary: 'bg-accent1-gradient',
//   secondary: 'bg-accent2-gradient',
//   notActive: 'bg-placeholder',
// }

// export type TagProps = React.ComponentProps<'span'> & {
//   variantColor: keyof typeof tagColor
// }

// export const Tag = ({
//   className,
//   children,
//   variantColor,
//   ...props
// }: TagProps) => {
//   const tagClass = useClass(
//     'py-2 px-4 rounded-[4px] bg-gray-100 text-xs font-bold',
//     tagColor[variantColor],
//     className
//   )

//   return (
//     <span className={tagClass} {...props}>
//       {children}
//     </span>
//   )
// }

import Image from 'next/image'
import React from 'react'

import { useClass } from '@/hooks/useClass'

export enum TagType {
  free = 'free',
  waitFree = 'waitFree',
  adFree = 'adFree',
  price = 'price',
  creator = 'creator',
}

const tagColor = {
  waitFree: 'border-[#2FFF44] text-[#2FFF44]',
  adFree: 'border-[#2FFFFF] text-[#2FFFFF]',
  free: 'border-[#FF9137] text-[#FF9137]',
  creator: 'bg-accent2-gradient',
}

export type TagProps = React.ComponentProps<'span'> & {
  variantColor: keyof typeof tagColor
}

export const Tag = ({
  className,
  children,
  variantColor,
  ...props
}: TagProps) => {
  const tagClass = useClass(
    'py-2 px-4 rounded-[4px] bg-gray-100 text-xs font-bold border flex shrink-0',
    tagColor[variantColor],
    className
  )

  if (variantColor === 'waitFree') {
    return (
      <span className={tagClass} {...props}>
        <span className="inline-flex items-center">
          <Image
            src={'/wait-free.svg'}
            width={15}
            height={15}
            alt="wait-free"
          />
        </span>{' '}
        <span>{children}</span>
      </span>
    )
  }
  if (variantColor === TagType.free) {
    return (
      <span className={tagClass} {...props}>
        <span className="inline-flex items-center">
          <Image src={'/free.svg'} width={15} height={15} alt="free" />
        </span>{' '}
        {children}
      </span>
    )
  }
  if (variantColor === TagType.adFree) {
    return (
      <span className={tagClass} {...props}>
        <span className="inline-flex items-center">
          <Image src={'/ad-free.svg'} width={15} height={15} alt="ad-free" />
        </span>{' '}
        {children}
      </span>
    )
  }

  if (variantColor === TagType.creator) {
    return (
      <span className={tagClass} {...props}>
        {children}
      </span>
    )
  }

  return (
    <span className={tagClass} {...props}>
      <span className="inline-flex items-center">
        <Image src={'/wait-free.svg'} width={15} height={15} />
      </span>{' '}
      {children}
    </span>
  )
}
